<button [attr.data-theme]="theme()" [attr.data-active]="active()" class="group">
  <app-icon [name]="icon()" />
  <div class="flex flex-col">
    <ng-content />
  </div>
</button>
